import React, { Component } from 'react'
import {
    Container
} from 'reactstrap'
import FormEmpresa from './formEmpresa'
import InfoEmpresaObj from '../../../utils/empresa'
const empresa = new InfoEmpresaObj()

export default class AdminEmpresa extends Component {
    constructor(props) {
        super(props)

        this.state = {
            infoEmpresa: {},
            guardando: false,
            error: null
        }
        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    onChange(e) {
        this.setState({
            infoEmpresa: {
              ...this.state.infoEmpresa,
              [e.target.id]: e.target.value
            }
          })
    }

    onSubmit(e) {
        e.preventDefault()
        const _this = this
        _this.setState({ guardando: true})
        empresa.guardarInfoEmpresa(_this.state.infoEmpresa)
        .then(_this.setState({
            guardando:false,
            error: null
        }))
        .catch(error => _this.setState({error, guardando: false}))
    }

    componentWillMount() {
        const _this = this
        empresa.getInfoEmpresa().then(infoEmpresa => {
            _this.setState({
                infoEmpresa
            })
        })
    }

    render() {
        window.scrollTo(0, 0)
        return (
            <Container>
                <h2>Información de empresa</h2>
                <FormEmpresa
                    infoEmpresa={this.state.infoEmpresa}
                    onChange={this.onChange}
                    onSubmit={this.onSubmit}
                    guardando={this.state.guardando}
                    error={this.state.error}
                />
            </Container>
        )
    }
}